var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46404 1.51825C-0.217927 3.17619 -0.506263 2.33521 8.64843 22.4707C15.9049 38.4013 16.866 40.3957 17.5869 40.8762C18.524 41.525 19.7254 41.5731 20.8787 41.0444C21.6236 40.684 21.984 40.0593 24.6752 34.7251C26.3811 31.3131 27.9189 28.5498 28.3034 28.1654C28.6878 27.829 31.5952 26.2431 34.791 24.6573C40.0291 22.0382 40.6298 21.6778 40.9902 20.9329C41.5188 19.7796 41.4708 18.5782 40.846 17.6411C40.3415 16.9202 38.3471 15.9591 22.4165 8.70265C2.28099 -0.452048 3.12198 -0.163711 1.46404 1.51825Z",
    fill: "url(#paint0_linear_900_432)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_900_432",
    x1: 5.0443,
    y1: 1.12461,
    x2: 38.6594,
    y2: 35.5608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D6F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.763a770225f3584f8b5df563d56b33d5.svg";
export { ForwardRef as ReactComponent };